<template>
	<footer class="app-footer">
		<span><a href="https://avtotehnika-celje.si">ATC Tabla vozil</a> &copy; 2018 Avtotehnika Celje d.o.o.</span>
		<span class="ml-auto">Powered by <a href="https://avtotehnika-celje.si">ATC BI</a></span>
	</footer>
</template>
<script>
export default {
	name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue